export const maxZipCityEstateIds = 10;
export const defaultPerimeter = 10;
export type OptionProps = {
  value: number;
  label: string;
};
